
import React from 'react';
import { Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import SpeakerImage from './SpeakerImage';
import SpeakerBio from './SpeakerBio';
import AgendaShareButton from '../AgendaShareButton';
import FeatureToggleUtils from 'FeatureToggleUtils';

const Props = {
    bio: PropTypes.object.isRequired,
    profileImage: PropTypes.object,
    goBack: PropTypes.func.isRequired,
    eventUrls: PropTypes.object,
    showEmailLogin: PropTypes.func.isRequired,
};



const SpeakerProfile = ({
    bio,
    profileImage,
    goBack,
    eventUrls,
    showEmailLogin,
    event,
    speakerId,
    siteConf,
    setLoginV2OffsetTop,
}) => {
    const featureAgendaShare = FeatureToggleUtils.isFeatureEnabled('agendaShare');

    return (
        <Row className="speaker-profile margin-bottom-small">
            <button
                className="speaker-back-button bz-flex-row font-size-12 custom-color color-1-background color-5"
                onClick={goBack}>
                <i className="fa icon-AgendaAtt_arrow speaker-back-arrow padding-left-xs"/>
                <span className="speaker-back-button-label font-size-12">BACK</span>
            </button>
            {featureAgendaShare && <AgendaShareButton event={event} eventUrls={eventUrls} entityId={speakerId} entityToShare='Speaker' color={siteConf.color1}/>}
            <Col xs={12} lg={3} md={5} className="
            speaker-image-wrapper
            medium-padding-right-none
            bz-flex-row">
                <SpeakerImage {...profileImage} />
            </Col>
            <Col className="
            speaker-bio-wrapper
            medium-padding-right-medium
            medium-padding-left-medium
            padding-top-small
            padding-bottom-small
            padding-right-medium
            " xs={12} lg={9} md={7}>
                <SpeakerBio
                    {...bio}
                    showEmailLogin={showEmailLogin}
                    eventUrls={eventUrls}
                    siteConf={siteConf}
                    setLoginV2OffsetTop={setLoginV2OffsetTop}
                />
            </Col>
        </Row>
    );
};

SpeakerProfile.propType = Props;

export default SpeakerProfile;
